<template>
  <div>
    <OrderStatus pathName="program-statuses" />
  </div>
</template>

<script>
export default {
  name: "ProgramStatus",
  components: {
    OrderStatus: () => import("@/components/OrderStatus")
  }
};
</script>
